import React, { useContext, useEffect, useState } from "react";
import LineChart from "../../components/Charts/LineCart/LineChart";
import ParetoChart from "../../components/Charts/BarChart/BarChart";
import Search from "../../components/Searchbar/Search";
import Footer from "../../components/Footer/Footer";
import { cacAndCsrProblem } from "./KpiAnalysis";
import { FilterContext } from "../../context/Filter";
import Header from "../../components/Header/Header";
import NavButtons from "../../components/NevBar/NavButtons";

const Analysis = () => {
  const [complaintData, setComplaintData] = useState();
  const [activeL1, setActiveL1] = useState("L1");
  const { l2, setL2, searchData, setSearchData, selectedSearchType, setSelectedSearchType } = useContext(FilterContext);

  const fetchComplaintData = async (searchData) => {
    try {
      const apiData = await cacAndCsrProblem(searchData);
      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setComplaintData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setComplaintData([]);
    }
  };

  useEffect(() => {
    fetchComplaintData(searchData);
  }, []);

  // Reset Handler
  const handleReset = () => {
    console.log("Reset button clicked");
    setComplaintData(null);
    setSearchData([]);
    setSelectedSearchType("");
    setActiveL1("L1");
    setL2(true);
  };

  const formattedMonths = complaintData?.COMPLAINT_AREA_COUNT?.map((item) => {
    const shortMonth = item.month;
    return shortMonth;
  });

  const formattedProblemArea =
    complaintData?.PROBLEM_AREA_MONTH_WISE_COUNT?.map((item) => {
      const shortMonths = item.month;
      return shortMonths;
    });

  const formattedCountData = complaintData?.COMPLAINT_AREA_COUNT?.map(
    (item) => {
      const countData = item.doc_count;
      return countData;
    }
  );

  const formattedProblemAreaCount = complaintData?.PROBLEM_AREA?.map((item) => {
    const countData = item.doc_count;
    return countData;
  });

  const transformedData =
    complaintData?.COMPLAINT_AREA?.map(({ key, doc_count }) => ({
      name: key,
      value: doc_count,
    })) || [];

  const transformedDataProblem =
    complaintData?.PROBLEM_AREA?.map(({ key, doc_count }) => ({
      name: key,
      value: doc_count,
    })) || [];

  const sampleCount =
    complaintData?.PROBLEM_AREA_MONTH_WISE_COUNT?.map(({ key, doc_count }) => ({
      name: key,
      value: doc_count,
    })) || [];

  let data, monthData, count;
  if (l2 === true) {
    data = transformedData;
    monthData = formattedMonths;
    count = formattedCountData;
  }

  if (l2 === false) {
    data = transformedDataProblem;
    monthData = formattedProblemArea;
    count = sampleCount;
  }

  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "--";

  return (
    <>
      <Header />
      <Search
        selectedSearchType={selectedSearchType}
        setSelectedSearchType={setSelectedSearchType}
        searchData={searchData}
        setSearchData={setSearchData}
        setComplaintData={setComplaintData}
        activeL1={activeL1}
        handleReset={handleReset}
        className="relative"
      />

      {/* Reset Button Section */}
      <div className=" lg:absolute top-12 mt-3  right-48 bg-gray-50 px-4 py-1 flex justify-end">
        <button
          onClick={handleReset}
          className="px-4 py-1 bg-gray-200 hover:bg-gray-300 rounded-md text-gray-700 border border-gray-300 transition-colors duration-200 flex items-center gap-2 shadow-sm"
        >

          Reset
        </button>
      </div>

      <div className="text-center bg-gray-50 p-2">
        <div className="block md:flex gap-2 w-full">
          <div className="w-full md:w-3/5">
            <ParetoChart data={data} isChanged={true} l2={l2} />
          </div>
          <div className="w-full md:w-2/5">
            <LineChart
              data={count}
              months={monthData}
              isChanged={true}
              name={
                l2 === true
                  ? capitalize(transformedData?.[0]?.name) || "--"
                  : capitalize(transformedDataProblem?.[0]?.name) || "--"
              }
            />
          </div>
        </div>
        <Footer l2={l2} setL2={setL2} />
      </div>
      {/* <NavButtons /> */}
    </>
  );
};

export default Analysis;